import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CLASS_MATERIALS_MANAGE_BASE, TEACHER_TRAINING_MANAGE_BASE } from '../../../config/contentRoutes';

const NotesManagement: React.FC = () => {
  const navigate = useNavigate();

  const managementSections = [
    {
      id: 'materials-management',
      title: '내 수업 자료 관리',
      description: '교사 개인 계정으로 수업 자료를 등록·수정합니다. 공개 페이지와 URL이 다릅니다.',
      icon: '📚',
      color: '#1976d2',
      path: CLASS_MATERIALS_MANAGE_BASE,
    },
    {
      id: 'training-management',
      title: '내 연수 관리',
      description: '교사 개인 계정으로 연수 페이지를 등록·수정합니다. 공개 페이지와 URL이 다릅니다.',
      icon: '🎓',
      color: '#388e3c',
      path: TEACHER_TRAINING_MANAGE_BASE,
    },
  ];

  return (
    <div
      style={{
        maxWidth: '960px',
        margin: '0 auto',
        padding: '2rem',
        backgroundColor: 'var(--Color-background-main)',
        minHeight: '100%',
        fontFamily: 'var(--font-family-primary)',
      }}
    >
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--Color-text-strong)' }}>
          콘텐츠 관리 바로가기
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--Color-text-normal)', margin: 0, lineHeight: 1.6 }}>
          방문자용 공개 페이지와 교사 개인 관리 페이지는 분리되어 있습니다. 아래에서 내 관리 페이지로 이동하세요.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {managementSections.map((section) => (
          <button
            key={section.id}
            type="button"
            onClick={() => navigate(section.path)}
            style={{
              textAlign: 'left',
              backgroundColor: 'var(--Color-background-normal)',
              borderRadius: '16px',
              padding: '1.5rem',
              border: '1px solid var(--Color-line-normal)',
              cursor: 'pointer',
            }}
          >
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{section.icon}</div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '0 0 0.5rem', color: 'var(--Color-text-strong)' }}>
              {section.title}
            </h2>
            <p style={{ margin: 0, color: 'var(--Color-text-normal)', fontSize: '14px', lineHeight: 1.6 }}>
              {section.description}
            </p>
            <span style={{ display: 'inline-block', marginTop: '1rem', color: section.color, fontWeight: 600, fontSize: '14px' }}>
              이동하기 →
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default NotesManagement;
